import { render, staticRenderFns } from "./StudentEditView.vue?vue&type=template&id=62c9916e&scoped=true&"
import script from "./StudentEditView.vue?vue&type=script&lang=ts&"
export * from "./StudentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./StudentEditView.vue?vue&type=style&index=0&id=62c9916e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c9916e",
  null
  
)

export default component.exports